import {Injectable} from '@angular/core'
import {UntypedFormGroup, ValidatorFn, Validators} from '@angular/forms'

@Injectable({
  providedIn: 'root',
})
export class FormService {
  private static phoneNumberPattern = /(\+41|0041)?[\s]?[0-9]{2}[\s]?[0-9]{3}[\s]?[0-9]{2}[\s]?[0-9]{2}$/

  // An IBAN pattern that validates Swiss IBANs and also that it's a non-QR IBAN
  private static chPatternForNonQRSwissIBANs =
    /^CH[a-zA-Z0-9]{2}\s?((?!3[0-1])([0-9]{4}\s?)){1}([0-9]{1})([a-zA-Z0-9]{3}\s?)([a-zA-Z0-9]{4}\s?){2}([a-zA-Z0-9]{1})\s?$/

  // eslint-disable-next-line max-len
  private static emailPattern =
    /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/

  private static wholeNumberPattern = /^[0-9]*$/

  private static numberPattern = /^-?[0-9][0-9,.]+$/

  private static slugPattern = /^[a-z0-9-]+$/i

  static markAllAsDirty(formGroup: UntypedFormGroup): void {
    Object.entries(formGroup.controls).forEach(([, control]) => control.markAsDirty())
  }

  static mobileNumberValidator(): ValidatorFn {
    return Validators.pattern(FormService.phoneNumberPattern)
  }

  static emailValidator(): ValidatorFn {
    return Validators.pattern(FormService.emailPattern)
  }

  static nonQrSwissIbanValidator(): ValidatorFn {
    return Validators.pattern(FormService.chPatternForNonQRSwissIBANs)
  }

  static wholeNumberValidator(): ValidatorFn {
    return Validators.pattern(FormService.wholeNumberPattern)
  }

  static numberValidator(): ValidatorFn {
    return Validators.pattern(FormService.numberPattern)
  }

  static slugCharsValidator(): ValidatorFn {
    return Validators.pattern(FormService.slugPattern)
  }
}
